import type { NodeId } from '@ipfabric/utils';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import { propOf } from '@ipfabric/utils/fp/prop';
import type { GraphData } from 'components/Graph/model/GraphData';
import { flow, pipe } from 'fp-ts/lib/function';
import type { Draft } from 'immer';

/**
 * Remove edges connected to given nodes from GraphData
 */
export const destroyEdgesByNodes = (
  draft: Draft<GraphData>,
  nodeIdsToDestroyTheirEdges: Set<NodeId>,
): void => {
  pipe(
    nodeIdsToDestroyTheirEdges,
    plainSet.forEach(
      flow(
        propOf(draft.nodesEdgesMap),
        // biome-ignore lint/complexity/noForEach: not object syntax
        plainSet.forEach((edgeId) => {
          delete draft.edges[edgeId];
        }),
      ),
    ),
  );
};
